/* eslint-disable no-undef */
import fontLoad from '@/services/fontLoad';

export default function useFontLoader() {
  const DEFAULT_FONT = 'Arial, sans-serif'

  async function loadFont(font) {
    if (!font) {
      console.warn("useFontLoader: font is required")
      return
    }

    const normalizedFont = font.toLowerCase();

    // Emit the default font if the requested font is 'arial' or matches the default font.
    if (normalizedFont === 'arial' || normalizedFont === DEFAULT_FONT.toLowerCase()) {
      return DEFAULT_FONT;
    }

    // Don't load normalizedFont string
    return await fontLoad(font);
  }

  return {
    loadFont
  }
}
